(() => {
  const config = JSON.parse(document.getElementById('KisScreenConfig').textContent);
  config.screenProducts = config.screenProducts.map(Number).filter(id => Number.isSafeInteger(id) && id > 0);
  const root = window.Shopify?.routes?.root || config.root;
  let queue = Promise.resolve();
  let active = config.active;
  let pending = 0;
  const fields = ['_screen_front', '_screen_back'];
  const includedPlate = item => String(item.variant_title || '').includes('$35 Plate Fee');
  const normalize = value => String(value || '').normalize('NFC').trim().toLowerCase().replace(/\s+/g, ' ');
  const keyFor = value => 'screen-v1:' + normalize(value);
  const sections = () => ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'main-cart-footer'];
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    } : undefined);
    const data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || config.error);
    return data;
  };
  const plan = cart => {
    const wanted = new Map();
    if (cart.items.some(item => config.screenProducts.includes(Number(item.product_id)) && !includedPlate(item) && item.properties?._screen_print !== '1')) throw new Error(config.legacyError);
    const seen = new Set();
    const updates = {};
    for (const item of cart.items) {
      if (includedPlate(item) || item.properties?._screen_print !== '1' || item.quantity <= 0) continue;
      for (const field of fields) {
        const label = item.properties[field];
        if (label) wanted.set(keyFor(label), label);
      }
    }
    for (const item of cart.items) {
      const key = item.properties?._screen_fee;
      if (!key || Number(item.variant_id || item.id) !== Number(config.feeVariant)) continue;
      const quantity = wanted.has(key) && !seen.has(key) ? 1 : 0;
      seen.add(key);
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    const add = [...wanted].filter(([key]) => !seen.has(key)).map(([key, artwork]) => ({
      id: Number(config.feeVariant), quantity: 1,
      properties: { _screen_fee: key, Artwork: artwork }
    }));
    return { updates, add };
  };
  const reconcile = async (cart, renderSections = []) => {
    const changes = plan(cart);
    if (Object.keys(changes.updates).length) {
      cart = await request('cart/update.js', { updates: changes.updates, sections: renderSections, sections_url: location.pathname });
    }
    if (changes.add.length) {
      await request('cart/add.js', { items: changes.add });
      cart = await request('cart/update.js', { updates: {}, sections: renderSections, sections_url: location.pathname });
    }
    active = cart.items.some(item => (!includedPlate(item) && item.properties?._screen_print === '1') || item.properties?._screen_fee);
    return cart;
  };
  const lock = callback => {
    pending++;
    const task = queue.then(callback);
    queue = task.catch(() => {});
    return task.finally(() => { pending--; });
  };
  const showCart = cart => {
    for (const [id, html] of Object.entries(cart.sections || {})) {
      if (!html) continue;
      const source = new DOMParser().parseFromString(html, 'text/html');
      const current = document.getElementById(id);
      const replacement = source.getElementById(id);
      if (current && replacement) current.innerHTML = replacement.innerHTML;
      else if (id === 'cart-icon-bubble' && current) {
        const content = source.querySelector('.shopify-section');
        if (content) current.innerHTML = content.innerHTML;
      }
      else if (id === 'main-cart-items' || id === 'main-cart-footer') {
        const target = document.getElementById(id)?.querySelector('.js-contents');
        const content = source.querySelector('.js-contents');
        if (target && content) target.innerHTML = content.innerHTML;
      }
    }
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
  };
  const submit = async (component, event) => {
    event.preventDefault();
    const form = component.form;
    const panel = form.querySelector('[data-screen-print]');
    const front = panel.querySelector('[data-screen-front]').value.trim();
    const different = panel.querySelector('[data-screen-design]').value === 'different';
    const variant = JSON.parse(panel.querySelector('[data-screen-variants]').textContent).find(v => String(v.id) === form.querySelector('[name=id]').value);
    const back = variant?.sides === 2 ? (different ? panel.querySelector('[data-screen-back]').value.trim() : front) : '';
    if (!front || (variant?.sides === 2 && different && (!back || normalize(front) === normalize(back)))) {
      component.handleErrorMessage(config.artworkError);
      return;
    }
    if (!variant || !config.feeAvailable) { component.handleErrorMessage(config.error); return; }
    if (component.submitButton.getAttribute('aria-disabled') === 'true') return;
    component.handleErrorMessage();
    component.submitButton.setAttribute('aria-disabled', true);
    component.submitButton.classList.add('loading');
    component.querySelector('.loading__spinner')?.classList.remove('hidden');
    try {
      await lock(async () => {
        const data = new FormData(form);
        const properties = {};
        for (const [name, value] of data.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        Object.assign(properties, { _screen_print: '1', _screen_front: front, _screen_back: back, Artwork: front });
        if (back && different) properties['Back artwork'] = back;
        const parent = { id: variant.id, quantity: Number(data.get('quantity') || 1), properties };
        if (!Number.isSafeInteger(parent.quantity) || parent.quantity < 1) throw new Error(config.error);
        let cart = await request('cart.js');
        const missing = plan({ items: [...cart.items, { ...parent, variant_id: parent.id }] }).add;
        await request('cart/add.js', { items: [parent, ...missing] });
        active = true;
        cart = await request('cart/update.js', { updates: {}, sections: sections(), sections_url: location.pathname });
        cart = await reconcile(cart, sections());
        showCart(cart);
        if (typeof publish === 'function') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kis-screen-print', cartData: cart });
        const drawer = document.querySelector('cart-drawer');
        if (drawer) { drawer.setActiveElement(component.submitButton); drawer.open(component.submitButton); }
        else location.assign(window.routes.cart_url);
      });
    } catch (error) { component.handleErrorMessage(error.message || config.error); }
    finally {
      component.submitButton.removeAttribute('aria-disabled');
      component.submitButton.classList.remove('loading');
      component.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  };
  const cartFetch = (url, options) => {
    if (!active && !pending) return fetch(url, options);
    const change = JSON.parse(options.body);
    const row = document.getElementById('CartItem-' + change.line) || document.getElementById('CartDrawer-Item-' + change.line);
    if (row?.dataset.lineKey) { change.id = row.dataset.lineKey; delete change.line; options = { ...options, body: JSON.stringify(change) }; }
    return lock(async () => {
      const response = await fetch(url, options);
      const data = await response.clone().json();
      if (!response.ok || data.errors) return response;
      const body = JSON.parse(options.body);
      if (data.items.some(item => config.screenProducts.includes(Number(item.product_id)) && !includedPlate(item) && item.properties?._screen_print !== '1')) return response;
      const cart = await reconcile(data, body.sections || []);
      return new Response(JSON.stringify(cart), { status: response.status, headers: response.headers });
    });
  };
  let checkoutReady = false;
  const checkout = async event => {
    if (checkoutReady || (!active && !pending)) return;
    const target = event.target.closest?.('[name=checkout],a[href*="/checkout"]');
    if (!target && !(event.type === 'submit' && event.submitter?.name === 'checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await lock(async () => {
        let cart = await request('cart.js');
        const updates = {};
        document.querySelectorAll('.cart-item[data-line-key] .quantity__input:not([readonly])').forEach(input => {
          const key = input.closest('[data-line-key]').dataset.lineKey;
          const item = cart.items.find(item => item.key === key);
          const quantity = Number(input.value);
          if (item && Number.isSafeInteger(quantity) && quantity >= 0 && item.quantity !== quantity) updates[key] = quantity;
        });
        if (Object.keys(updates).length) cart = await request('cart/update.js', { updates });
        await reconcile(cart);
      });
      checkoutReady = true;
      location.assign(root + 'checkout');
    } catch (error) {
      const output = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (output) output.textContent = error.message || config.error;
      checkoutReady = false;
    }
  };
  const updatePanel = panel => {
    const form = panel.closest('form');
    const variant = JSON.parse(panel.querySelector('[data-screen-variants]').textContent).find(v => String(v.id) === form.querySelector('[name=id]').value);
    const double = variant?.sides === 2;
    panel.querySelector('[data-screen-design-row]').hidden = !double;
    panel.querySelector('[data-screen-back-row]').hidden = !double || panel.querySelector('[data-screen-design]').value !== 'different';
  };
  document.addEventListener('change', event => {
    const panel = event.target.closest('form')?.querySelector('[data-screen-print]');
    if (panel) updatePanel(panel);
  });
  document.addEventListener('product-info:loaded', () => document.querySelectorAll('[data-screen-print]').forEach(updatePanel));
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  window.KisScreenPrint = { enabled: form => !!form.querySelector('[data-screen-print]'), submit, cartFetch, plan, keyFor };
  document.querySelectorAll('[data-screen-print]').forEach(updatePanel);
})();

